<template>
  <div class="whyChoose">
    <div class="mainContent">
      <div class="title">拥有全面且领先的功能支撑 / 全面领先</div>
      <div class="flex" style="flex-wrap: wrap; padding: 0 4rem;justify-content: center!important">
        <img
          v-for="(item, idx) in imgList"
          :key="idx"
          :src="item"
          alt=""
          class="imgItem"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import img01 from "@/assets/imgs/replay/img01.png";
import img02 from "@/assets/imgs/replay/img02.png";
import img03 from "@/assets/imgs/replay/img03.png";
import img04 from "@/assets/imgs/replay/img04.png";
import img05 from "@/assets/imgs/replay/img05.png";
import img06 from "@/assets/imgs/replay/img06.png";
import img07 from "@/assets/imgs/replay/img07.png";
import img08 from "@/assets/imgs/replay/img08.png";
import img09 from "@/assets/imgs/replay/img09.png";
import img10 from "@/assets/imgs/replay/img10.png";
import img11 from "@/assets/imgs/replay/img11.png";
import img12 from "@/assets/imgs/replay/img12.png";
const imgList = [
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
];

onMounted(() => {});
</script>
<style scoped>
.whyChoose {
  background-color: #f7f7f7;
}

.mainContent {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 2rem 0 3rem;
}

.title {
  text-align: left;
  font-size: 2rem;
  margin-bottom: 2.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: #131313;
}

.imgItem {
  display: inline-block;
  min-width: 150px;
  height: 150px;
  margin: 5px;
  border-radius: 15px;
  border: 1px solid #dae2ec;
}
.imgItem:hover {
  border: 1px solid #adbed4;
}
@media (max-width: 768px) {
}
</style>